import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Alert from '@material-ui/lab/Alert';
import Dialog from 'Components/UI/Dialog';
import Button from 'Components/UI/Button';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = theme => ({
  root: {},
  title: {
    paddingRight: theme.spacing(6),
    paddingTop: '13px',
  },
  alertMessage: {
    marginBottom: theme.spacing(4),
    fontSize: '1em',
  },
});

const ConfirmationDialog = ({
  classes,
  onConfirm,
  onCancel,
  onReschedule,
  message,
  alertMessage,
  alertType,
  children,
  title,
  cancelLabel,
  confirmLabel,
  rescheduleLabel,
  className,
  isLoading,
  ...rest
}) => (
  <Dialog
    className={classNames(classes.root, className)}
    maxWidth="xs"
    onClose={onCancel}
    open
    {...rest}
  >
    <DialogTitle
      className={classes.title}
    >
      {title}
    </DialogTitle>
    <DialogContent>
      {alertMessage && (
      <Alert
        className={classes.alertMessage}
        severity={alertType}
      >
        {alertMessage}
      </Alert>
      )}
      <Typography variant="body1">{message}</Typography>
      {children}
    </DialogContent>
    <DialogActions>
      <Button
        color="primary"
        variant="text"
        onClick={onReschedule}
        disabled={isLoading}
      >
        {rescheduleLabel}
      </Button>
      <Button
        color="primary"
        variant="text"
        onClick={onCancel}
        disabled={isLoading}
      >
        {cancelLabel}
      </Button>
      <Button
        color="primary"
        disableElevation
        variant="contained"
        onClick={onConfirm}
        disabled={isLoading}
      >
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmationDialog.propTypes = {
  children: PropTypes.node,
  message: PropTypes.string.isRequired,
  alertMessage: PropTypes.string,
  alertType: PropTypes.oneOf(['info', 'error', 'warning', 'success']),
  title: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

ConfirmationDialog.defaultProps = {
  cancelLabel: 'Cancel',
  children: null,
  confirmLabel: 'Yes',
  title: 'Are you sure?',
  className: '',
  alertMessage: null,
  alertType: 'info',
};

export default withStyles(styles)(ConfirmationDialog);
